import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import OutlineInvoice from 'Components/Atoms/OutlineIcons/OutlineInvoice';
import { INVOICE_TYPES } from 'Utils/constants';
import Icon from 'Components/Atoms/Icon/Icon';

export default function IconInvoiceType(props) {
    const { invoice } = props;

    const isIncome = invoice.type === INVOICE_TYPES.SALE;

    if (['pending_cancellation', 'processing'].includes(invoice.tax_authority_provider_status)) {
        return (
            <div className="size-8 flex justify-center items-center rounded-sm bg-[#6050C6]/5 shrink-0">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="56"
                    height="56"
                    fill="none"
                    viewBox="0 0 56 56"
                    className="animate-spin size-6"
                >
                    <path stroke="#ffffff" strokeWidth={8} d="M52 28a24 24 0 1 1-48 0 24 24 0 0 1 48 0Z"></path>
                    <path
                        stroke="url(#loading-gradient)"
                        strokeLinecap="round"
                        strokeWidth={8}
                        d="M52 28a24 24 0 0 1-48 0"
                    ></path>
                    <defs>
                        <linearGradient
                            id="loading-gradient"
                            x1="28"
                            x2="56.5"
                            y1="52"
                            y2="16"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#A74EFF"></stop>
                            <stop offset="1" stopColor="#393992"></stop>
                        </linearGradient>
                    </defs>
                </svg>
            </div>
        );
    }

    if (invoice.tax_authority_provider_status === 'draft') {
        return (
            <div className="size-8 flex justify-center items-center rounded-sm bg-dark-blue/10 shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" fill="none" viewBox="0 0 16 19">
                    <g stroke="#11112C" strokeWidth="1.5" opacity="0.25">
                        <path
                            strokeDasharray="3 3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9.75.75h-7.2a1.8 1.8 0 0 0-1.8 1.8v13.4a1.8 1.8 0 0 0 1.8 1.8h10.8a1.8 1.8 0 0 0 1.8-1.8v-9.8z"
                            clipRule="evenodd"
                        ></path>
                        <path d="M7.25 4.25h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"></path>
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M7.55 10.65h-3.2M11.55 10.65h-1.2M11.55 14.25h-1.2M7.55 14.25h-3.2"
                        ></path>
                    </g>
                </svg>
            </div>
        );
    }

    if (invoice.tax_authority_provider_status === 'cancelled') {
        return (
            <div className="size-8 flex justify-center items-center rounded-sm bg-dark-blue/10 shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" fill="none" viewBox="0 0 16 19">
                    <g stroke="#11112C" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" opacity="0.5">
                        <path
                            d="M10.043 1.043A1 1 0 0 0 9.336.75H2.55a1.8 1.8 0 0 0-1.8 1.8v13.4a1.8 1.8 0 0 0 1.8 1.8h10.8a1.8 1.8 0 0 0 1.8-1.8V6.564a1 1 0 0 0-.293-.707z"
                            clipRule="evenodd"
                        ></path>
                        <path d="m4.804 6.804 5.893 5.893m1.22-2.946a4.167 4.167 0 1 1-8.333 0 4.167 4.167 0 0 1 8.333 0"></path>
                    </g>
                </svg>
            </div>
        );
    }

    if (['error_cancellation', 'error'].includes(invoice.tax_authority_provider_status)) {
        return (
            <div className="size-8 flex justify-center items-center rounded-sm bg-danger/10 shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" viewBox="0 0 21 20">
                    <path
                        fill="#F44854"
                        d="M8.339 2.908c.774-1.308 2.668-1.308 3.442 0l6.552 11.073c.789 1.334-.172 3.019-1.72 3.019H3.506c-1.55 0-2.51-1.685-1.72-3.019zM10.06 13c-.555 0-1.006.448-1.006 1s.451 1 1.006 1c.556 0 1.006-.448 1.006-1s-.45-1-1.006-1m0-8c-.555 0-1.006.45-1.006 1.006v4.988a1.007 1.007 0 0 0 2.012 0V6.006c0-.555-.45-1.006-1.006-1.006"
                    ></path>
                </svg>
            </div>
        );
    }

    if (invoice.tax_authority_provider_status === 'error_issuing_solved') {
        return (
            <div className="size-8 flex justify-center items-center rounded-sm bg-[#6050C6]/10 shrink-0">
                <Icon name="circle-check" color="#6050C6" size={20} />
            </div>
        );
    }

    if (invoice.tax_authority_provider_status === 'issued') {
        return (
            <div className={cn('size-8 flex justify-center items-center relative rounded-sm bg-[#6050C6]/10 shrink-0')}>
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
                    <g stroke="#6050C6" strokeWidth="1.5">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M20.4 14.72v6.9a1.8 1.8 0 0 1-1.8 1.8H7.8a1.8 1.8 0 0 1-1.8-1.8V8.22a1.8 1.8 0 0 1 1.8-1.8h4.6"
                        ></path>
                        <path d="M12.5 9.92h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"></path>
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12.8 16.32H9.6M16.8 16.32h-1.2M16.8 19.92h-1.2M12.8 19.92H9.6"
                        ></path>
                    </g>
                    <circle
                        cx="20.115"
                        cy="7.517"
                        r="5.316"
                        fill="#6050C6"
                        transform="rotate(-135 20.115 7.517)"
                    ></circle>
                    <path
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.2"
                        d="m17.75 7.636 1.797 1.683 3.203-3"
                    ></path>
                </svg>
            </div>
        );
    }

    return (
        <div
            className={cn(
                'size-8 flex justify-center items-center relative rounded-sm bg-gray-200 text-gray-500 shrink-0',
                isIncome ? 'text-[#43884D] bg-[#43884D]/10' : 'text-[#7C7C8B] bg-[#7C7C8B]/10',
            )}
        >
            <div className={cn('absolute top-1 right-1 flex justify-center items-center')}>
                {isIncome ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 10 10">
                        <path fill="#6DA375" d="M5 10A5 5 0 1 0 5 0a5 5 0 0 0 0 10"></path>
                        <path
                            stroke="#fff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.071"
                            d="M5 2.857v4.286M2.857 5 5 7.143 7.143 5"
                        ></path>
                    </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 10 10">
                        <path fill="currentColor" d="M5 10A5 5 0 1 0 5 0a5 5 0 0 0 0 10"></path>
                        <path
                            stroke="#fff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.071"
                            d="M5 7.143V2.857m0 0L7.143 5M5 2.857 2.857 5"
                        ></path>
                    </svg>
                )}
            </div>

            <OutlineInvoice color="currentColor" size={20} />
        </div>
    );
}

IconInvoiceType.propTypes = {
    invoice: PropTypes.object.isRequired,
};
